import { useRef, useState } from 'react';
import { IssueList, RejectedFile, SnModal } from './common';
import { rangeWarnings } from './parse';
import { readNotesFile } from './readNotesFile';
import { emptySlides, replacementSummary, slidesByState } from './apply';
import './speakerNotes.css';

const list = (slides) => slides.join(', ');

// 2-qadam tepasi: natija xabari va "TXT'dan to'ldirish" (yangi fayl, tasdiqlash oynasi bilan).
// onReplace(pages) — faqat faylda bor sahifalar almashtiriladi.
export default function SpeakerNotesStep2Bar({ texts, sources, report, pageCount, onReplace }) {
    const inputRef = useRef(null);
    const [rejected, setRejected] = useState(null);
    const [notice, setNotice] = useState(null);
    const [pending, setPending] = useState(null); // { result, summary }

    const handleFile = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (!file) return;
        const result = await readNotesFile(file);
        setNotice(null);
        if (result.errors.length > 0) {
            setRejected(result);
            return;
        }
        setRejected(null);
        const summary = replacementSummary(texts, sources, result.pages);
        const warnings = [...result.warnings, ...rangeWarnings(result, pageCount)];
        if (summary.total === 0) {
            setNotice({ fileName: result.fileName, warnings, empty: true });
            return;
        }
        setPending({ result, summary, warnings });
    };

    const confirm = () => {
        onReplace(pending.result.pages);
        setNotice(pending.warnings.length ? { fileName: pending.result.fileName, warnings: pending.warnings } : null);
        setPending(null);
    };

    const aiSlides = slidesByState(texts, sources, 'ai');
    const blank = emptySlides(texts);

    return (
        <div className="sn-step2">
            {report && (
                <div className="sn-alert sn-alert--info" role="status" data-testid="sn-report">
                    <div>
                        Fayldan {report.filled} ta sahifa to'ldirildi.
                        {aiSlides.length > 0 && <> AI matni qolgan sahifalar: {list(aiSlides)} — tekshirib chiqing.</>}
                    </div>
                    {blank.length > 0 && <div>Bo'sh sahifalar: {list(blank)}.</div>}
                    {report.ignored?.length > 0 && (
                        <div>Faylda bor, lekin PDF'da yo'q sahifalar e'tiborsiz qoldirildi: {list(report.ignored)}.</div>
                    )}
                </div>
            )}

            <div className="sn-actions">
                <button type="button" className="sn-btn" onClick={() => inputRef.current?.click()}>
                    TXT'dan to'ldirish
                </button>
                <input
                    ref={inputRef}
                    type="file"
                    accept=".txt,text/plain"
                    className="sn-hidden"
                    data-testid="sn-step2-input"
                    onChange={handleFile}
                />
            </div>

            <RejectedFile result={rejected} />
            {notice && (
                <div className="sn-alert sn-alert--warning">
                    {notice.empty && <div>«{notice.fileName}»: fayldagi sahifalarning birortasi bu PDF'da yo'q — hech narsa o'zgarmadi.</div>}
                    <IssueList items={notice.warnings} />
                </div>
            )}

            {pending && (
                <SnModal
                    title="Matnlarni almashtirish"
                    onClose={() => setPending(null)}
                    footer={(
                        <>
                            <button type="button" className="sn-btn" onClick={() => setPending(null)}>Bekor qilish</button>
                            <button type="button" className="sn-btn sn-btn--primary" onClick={confirm}>Almashtirish</button>
                        </>
                    )}
                >
                    <p className="sn-confirm__text">
                        {pending.summary.total} ta sahifadagi matn fayldagi matn bilan almashtiriladi, shulardan {pending.summary.edited} tasi qo'lda tahrirlangan.
                    </p>
                    <p className="sn-confirm__hint">Sahifalar: {list(pending.summary.applied)}. Faylda yo'q sahifalarga tegilmaydi.</p>
                    {pending.warnings.length > 0 && <IssueList items={pending.warnings} />}
                </SnModal>
            )}
        </div>
    );
}
